export const appColours = {
  darkGreen: "#5c9d51",
  lightGreen: "#79b06a",
};
